import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-document',
  templateUrl: './icon-document.component.html',
  styleUrls: ['./icon-document.component.css']
})
export class IconDocumentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
